export const SEARCH_RESULTS_PER_PAGE_DEFAULT = 15;
export const SEARCH_RESULTS_PER_PAGE_MAX = 50;
export const SEARCH_RESULTS_CANDIDATE_WINDOW_MAX = 1000;
